export enum TabSelectionType {
    MyFolders,
    ViewFolders,
    FolderDetail,
}
